import axios from './configAxiosOrganizations';

export const postOrgCreateContract = async (org_id, requestData) => {
	return await axios.post(`/${org_id}/contract/create/`, requestData);
};
